

(function () {

    angular.module('tmx-app').controller('currencyCtrl', ['$state', '$mdSidenav', 'menu', 'CurrencyService', 'tmxResource','tmxUtility', 
        function CurrencyCtrl( $state, $mdSidenav, menu, CurrencyService, tmxResource,tmxUtility) {
            var currencyVM = this;
            currencyVM.menu = menu;
            currencyVM.columns = CurrencyService.columns;
            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            currencyVM.editPermission=tmxUtility.checkPermission("Private.Masterdata.Currency","Edit");

            currencyVM.onChildState = function () {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) return true;
            };

            currencyVM.mainGridOptions = {
                dataSource: {

                    transport: {
                        read: function (o) {
                            if (angular.isDefined(currencyVM.searchClear) && currencyVM.searchClear == false) {
                                if (exists(currencyVM.o)) {
                                    copy(currencyVM.o.data, ["filter"], o.data);
                                }
                            }
                            currencyVM.searchClear = false;
                            if (currencyVM.onChildState()) { return; }

                            if (!o.fromSideNav) {
                                if ($state.searchClear) {
                                    currencyVM.searchClear = true;
                                    $state.searchClear = undefined;
                                }
                            }
                            else {
                                o.data.firstPage = true;
                            }

                            currencyVM.o = angular.copy(o);
                            currencyVM.filters = currencyVM.o.data.filter;
                            tmxResource("Currency/List").getByParams(o, true).then(function (response) {
                                parseResppnse(response.data);
                                o.success(response);
                            });
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                    sort: [{ field: "CurrencyID", dir: "desc" }],
                },
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                sortable: true,
                scrollable: false,
                columns: currencyVM.columns
            };

            currencyVM.container = {};

            currencyVM.clickEdit = function (item) {
                $state.go($state.current.name + ".edit", {
                    "Id": item.CurrencyID
                });
            };

            currencyVM.toggle = function (navID) {
                $mdSidenav(navID)
                    .toggle()
                    .then(function () { });
            };            

            currencyVM.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };          

            function parseResppnse(data){
                data.forEach(function(dataItem){                                        
                    dataItem.StatusBKColor=tmxUtility.SetStatusBackgroundColor(dataItem.Status);                   
                });
            }

        }]);

})();
